import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=0fc39d65&scoped=true&"
import script from "./Site.vue?vue&type=script&lang=js&"
export * from "./Site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc39d65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc39d65')) {
      api.createRecord('0fc39d65', component.options)
    } else {
      api.reload('0fc39d65', component.options)
    }
    module.hot.accept("./Site.vue?vue&type=template&id=0fc39d65&scoped=true&", function () {
      api.rerender('0fc39d65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Setting/Site.vue"
export default component.exports